export const actionStatus = {
    SUCCESS: 'successfulActions',
    FAILURE: 'failedActions',
    ONGOING: 'ongoingActions',
    REBOOT_PENDING: 'isRebootPending',

};

